import { getAppLocale } from 'i18n/helpers';
import { getTimeAgo } from './helpers';

export const formatAccessibleTimestamp = (
  timestamp: string | undefined,
  justNowLabel: string,
): string => {
  if (!timestamp) {
    return '';
  }

  const timeAgo = getTimeAgo(timestamp);

  if (timeAgo === 'Just now') {
    return justNowLabel;
  }

  if (timeAgo) {
    return timeAgo;
  }

  const lang = getAppLocale()?.replace(/_/g, '-');

  if (!lang) {
    return '';
  }

  try {
    return new Intl.DateTimeFormat(lang, {
      dateStyle: 'medium',
      timeStyle: 'short',
    }).format(new Date(timestamp));
  } catch {
    return '';
  }
};
